import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { Toaster } from "sonner";
import ScrollToTop from "./components/ScrollToTop";
import GATracker from "./components/GATracker";
import GlobalSchema from "./components/GlobalSchema";
import WhatsAppWidget from "./components/WhatsAppWidget";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import CategoriesPage from "./pages/CategoriesPage";
import CategoryDetailPage from "./pages/CategoryDetailPage";
import ContactPage from "./pages/ContactPage";
import RequestSourcingPage from "./pages/RequestSourcingPage";
import ForBuyersPage from "./pages/ForBuyersPage";
import ForSuppliersPage from "./pages/ForSuppliersPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <GATracker />
          <GlobalSchema />
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/categories" element={<CategoriesPage />} />
            <Route path="/categories/:slug" element={<CategoryDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/request-sourcing" element={<RequestSourcingPage />} />
            <Route path="/for-buyers" element={<ForBuyersPage />} />
            <Route path="/for-suppliers" element={<ForSuppliersPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
          </Routes>
          <Footer />
          <WhatsAppWidget />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
